import React, { useEffect } from "react";
import CreditSummary from "../Credit/BusinessCreditReport/CreditSummary";
import { useSelector, useDispatch } from "react-redux";
import { IBusinessCreditReportResponse } from "../../store/businessCreditReportService/types";
import * as BusinessCreditReportAction from "../../store/businessCreditReportService/actions";
import { ApplicationState } from "../../store";

const BusinessCreditReportDialog = (props: any) => {
    const dispatch = useDispatch();
    const businessProfileStatus = useSelector(
        (state: ApplicationState) =>
            state.loggedInUser &&
            state.loggedInUser.userServiceDetails?.businessProfileStatus?.filter((obj: any) => {
                return obj.provider;
            })
    );
    const creditProvider = businessProfileStatus != null && businessProfileStatus.length > 0 ? businessProfileStatus[0].provider : "";
    const requestBusinessCreditReport = (ReportPK: any, forcefullyRefresh: boolean, creditProvider: string) =>
        dispatch(BusinessCreditReportAction.actionCreators.requestBusinessCreditReport(ReportPK, forcefullyRefresh, creditProvider));
    const creditReport: IBusinessCreditReportResponse = useSelector(
        (state: ApplicationState) => (state.businessCreditReportState && state.businessCreditReportState.creditReportData)!
    ).find((it) => it.Provider === creditProvider)!;

    useEffect(() => {
        document.querySelector<any>(`[aria-labelledby=${props.dialogId}-title]`)!.classList.add("width-xl");
        window.addEventListener("keyup", (evt: any) => {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = evt.key === "Escape" || evt.key === "Esc";
            } else {
                isEscape = evt.keyCode === 27;
            }
            if (isEscape) {
                props.closeDialog();
            }
        });
        return () => {
            window.removeEventListener("keyup", () => {});
        };
    });
    return (
        <React.Fragment>
            <div className="dialog-header">
                <h1>Credit Report</h1>
            </div>
            <div className="dialog-body large-dialog-scroll">
                <CreditSummary
                    bCreditReportData={creditReport}
                    reportObject={props.reportObject}
                    isForPrinting={false}
                    requestBusinessCreditReport={() => requestBusinessCreditReport(null, true, creditProvider)}
                    isPrintAndRefreshButtonShow={false}
                    creditProvider={creditProvider}
                    isFromDailog={true}
                />
            </div>

            <div className="dialog-footer">
                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null"></div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button
                            type="button"
                            className="btn-default btn-primary"
                            id="btn-ok-eft-text"
                            onClick={() => {
                                window.addToDataLayer({ event: "Protection Plan - Close EFT Acknowledgement" });
                                props.closeDialog();
                            }}
                        >
                            <span className="btn-text">Close</span>
                        </button>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default BusinessCreditReportDialog;
